@if (row.myChecks.length > 0) {
  <bic-badge [interactive]="true"
             [tooltip]="title"
             [tooltipContent]="list"
             [tooltipWidth]="tooltipWidth"
             tooltipDirection="bottom">
    <span class="inline-flex max-w-full min-w-0 items-center gap-1.5">
      <span class="truncate min-w-0">{{ row.myChecks[0].name }}</span>
      @if (row.myChecks.length > 1) {
        <span class="shrink-0 font-semibold text-gray-500">+{{ row.myChecks.length - 1 }}</span>
      }
    </span>
  </bic-badge>
} @else if (row.myCheckCount !== null) {
  <bic-badge>{{ row.myCheckCount === 1 ? '1 myCheck' : row.myCheckCount + ' myChecks' }}</bic-badge>
} @else {
  <span class="text-sm text-gray-500">–</span>
}

<ng-template #list>
  <div class="flex flex-col gap-2.5 w-[272px] pt-1">
    <div class="h-px w-full bg-white/20"></div>
    <div class="flex flex-col gap-1.5">
      @for (myCheck of row.myChecks; track $index) {
        <div class="flex flex-row items-center gap-2 min-w-0">
          <span class="truncate min-w-0 text-xs text-white">{{ myCheck.name }}</span>
          <span class="flex-1"></span>
          @if (myCheck.typeLabel) {
            <span class="shrink-0 rounded-md bg-gray-200 px-2.5 py-0.5 text-xs font-medium text-gray-700">{{ myCheck.typeLabel }}</span>
          }
        </div>
      }
    </div>
  </div>
</ng-template>
